// Typelizer digest 7e173e6a7e8b77c9a9c68eb5f5507969
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /c/:company_id/documents/archive_duplicates */
  archiveDuplicates: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/documents/archive_duplicates', {}, options),
    method: 'post',
  }),

  /** DELETE /c/:company_id/documents/bulk_destroy */
  bulkDestroy: (options?: RouteOptions): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/documents/bulk_destroy', {}, options),
    method: 'delete',
  }),

  /** PATCH /c/:company_id/documents/bulk_detach */
  bulkDetach: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/documents/bulk_detach', {}, options),
    method: 'patch',
  }),

  /** PATCH /c/:company_id/documents/bulk_update_counterparty */
  bulkUpdateCounterparty: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/documents/bulk_update_counterparty', {}, options),
    method: 'patch',
  }),

  /** PATCH /c/:company_id/documents/bulk_update_cash_flow_direction */
  bulkUpdateCashFlowDirection: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/documents/bulk_update_cash_flow_direction', {}, options),
    method: 'patch',
  }),

  /** GET /c/:company_id/documents */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/documents', {}, options),
    method: 'get',
  }),

  /** POST /c/:company_id/documents */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/documents', {}, options),
    method: 'post',
  }),

  /** GET /c/:company_id/documents/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/documents/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /c/:company_id/documents/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/documents/:id', params, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/documents/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/documents/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/documents/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/documents/:id', params, options),
    method: 'delete',
  }),
}
